// extracted by mini-css-extract-plugin
export default {"PdText":"QuestionForm_PdText__LwK0L","Link":"QuestionForm_Link__H+Ial"};